import pressablePrimaryDo from "../../../../../../packages/design-system/primitives/constellation/pressable/images/pressable-01a-do.png";
import pressablePrimaryDont from "../../../../../../packages/design-system/primitives/constellation/pressable/images/pressable-01b-dont.png";
import * as React from 'react';
export default {
  pressablePrimaryDo,
  pressablePrimaryDont,
  React
};